import React from 'react'
import styled from 'styled-components'
import { Link } from 'app/common/link'
import { style } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { restaurantServices } from 'shared/utils'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import { DeliverooLogo, UberEats } from 'app/assets/icons'

const { delivery, grey } = colors
const { DELIVEROO, UBEREATS } = restaurantServices

type Props = {
    className?: string,
    intl: IntlShape,
    deliverooUrl?: string,
    uberEatsUrl?: string,
    services: Array<string>
}

const ButtonsDeliveryComponent = (props: Props) => {
    const { className, intl, services, deliverooUrl, uberEatsUrl } = props

    if (!services) {
        return null
    }

    const hasDeliveroo = services.includes(DELIVEROO)
    const hasUberEats = services.includes(UBEREATS)
    return (
        <ButtonsContainer>
            {hasDeliveroo && (
                <StyledLink
                    url={
                        deliverooUrl ||
                        intl.formatMessage({
                            id: 'delivery.deliveroo.url'
                        })
                    }
                    external
                    className={className}>
                    <DeliverooIcon height={25} color={delivery} />
                </StyledLink>
            )}
            {hasUberEats && (
                <StyledLink
                    url={
                        uberEatsUrl ||
                        intl.formatMessage({
                            id: 'delivery.ubereats.url'
                        })
                    }
                    external
                    className={className}>
                    <UberEatsIcon height={10} />
                </StyledLink>
            )}
        </ButtonsContainer>
    )
}

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    margin-top: 10px;
`

const StyledLink = styled(Link)`
    ${style.buttonSmall};
    border: 1px solid ${grey};
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    margin: 5px;
    height: 16px;
    width: 100px;
`

const DeliverooIcon = styled(DeliverooLogo)`
    margin-left: 5px;
`

const UberEatsIcon = styled(UberEats)`
    margin-left: 5px;
`

const ButtonsDelivery = injectIntl(ButtonsDeliveryComponent)
export { ButtonsDelivery }
